class LoopingVideo {
  constructor(componentData) {
    // Extract the actual element and children from the framework structure
    this.element = componentData.element;
    this.children = componentData.children;
    this.options = componentData.options;

    this.init();
  }

  init() {
    // Access elements through the children object
    this.video = this.children?.video;
    this.button = this.children?.button;

    if (! this.video || ! this.button) {
      return;
    }

    this.bindEvents();
    this.updateButtonIcon(); // Set initial state
  }

  bindEvents() {
    this.button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.togglePlayback();
    });

    // Optional: Update button if video state changes externally
    this.video.addEventListener('play', () => this.updateButtonIcon());
    this.video.addEventListener('pause', () => this.updateButtonIcon());
  }

  togglePlayback() {
    if (this.video.paused) {
      this.video.play();
    } else {
      this.video.pause();
    }
    this.updateButtonIcon();
  }

  updateButtonIcon() {
    this.button.textContent = this.video.paused ? '▶' : '⏸';
  }
}

export default LoopingVideo;
